import * as React from "react";
import type { SVGProps } from "react";
const SvgMousePointer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m3 3 .385-.923a1 1 0 0 0-1.308 1.308zm7.07 16.97-.923.385a1 1 0 0 0 1.87-.063zm2.51-7.39-.322-.947a1 1 0 0 0-.625.625zm7.39-2.51.322.947a1 1 0 0 0 .063-1.87zm-6.263 2.223a1 1 0 0 0-1.414 1.414zm4.586 7.414a1 1 0 0 0 1.414-1.414zM2.077 3.385l7.07 16.97 1.846-.77-7.07-16.97zm8.94 16.907 2.51-7.39-1.894-.644-2.51 7.39zm1.885-6.765 7.39-2.51-.644-1.894-7.39 2.51zm7.453-4.38-16.97-7.07-.77 1.846 16.97 7.07zm-8.062 4.56 6 6 1.414-1.414-6-6z"
    />
  </svg>
);
export default SvgMousePointer;
